<template>
  <div class="loader">
    <img :src="fit20.storageBaseUrl + '/static/images/fit20-spiner-logo.png'" />
  </div>
</template>
<script>
export default {
  name: "Loader", props: ["fit20"],
};
</script>

<style>
.loader {
  width: 100%;
  height: 100%;
  z-index: 99999999999;
  background-color: rgba(255, 255, 255, 0.39);
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.loader img {
  display: block;
  animation: animationFrames 1.5s ease-in-out infinite;
  transform-origin: 50% 50%;
}

@keyframes animationFrames {
  0% {
    transform: translate(0px, 0px);
  }

  15% {
    transform: translate(0px, -25px);
  }

  30% {
    transform: translate(0px, 0px);
  }

  45% {
    transform: translate(0px, -15px);
  }

  60% {
    transform: translate(0px, 0px);
  }

  75% {
    transform: translate(0px, -5px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}
</style>
